import {writable} from "svelte/store";

/**
 * {
 *  detailsRecord: null,
 *  detailsOpened: boolean,
 *  filtersOpened: boolean,
 *  sectionsOpened: boolean,
 *  cartOpened: boolean
 * }
 *
 * @type {Writable<{detailsRecord: null, detailsOpened: boolean, filtersOpened: boolean, sectionsOpened: boolean, cartOpened: boolean}>}
 */
export const screensStore = writable({
    sectionsOpened: false,
    filtersOpened: false,
    cartOpened: false,
    detailsOpened: false,
    detailsRecord: null
});

export const toggleSectionsPanel = () => {

    screensStore.update(x => {
        x.sectionsOpened = !x.sectionsOpened;
        if (x.sectionsOpened) {
            x.filtersOpened = false;
            x.cartOpened = false;
        }

        return x;
    });
}

export const toggleAllergensFilterPanel = () => {
    screensStore.update(x => {
        x.filtersOpened = !x.filtersOpened;
        if (x.filtersOpened) {
            x.sectionsOpened = false;
            x.cartOpened = false;
        }
        return x;
    });
}

export const closeAllergensFilterPanel = () => {
    screensStore.update(x => {
        x.filtersOpened = false;
        return x;
    });
}

export const toggleDetailsScreen = (record) => {
    screensStore.update(x => {

        if (x.detailsRecord !== null) {
            x.detailsRecord = null;
            x.detailsOpened = false;
        } else {
            x.detailsRecord = record;
            x.detailsOpened = true;
        }

        return x;
    });
}

export const openCartScreen = () => {
    screensStore.update(x => {
        x.cartOpened = true;
        x.filtersOpened = false;
        x.sectionsOpened = false;
        return x;
    });
}

export const closeCartScreen = () => {
    screensStore.update(x => {
        x.cartOpened = false;
        return x;
    });
}
